import * as React from "react";
import HelpedSelect from "../../general/helped_select";

export default function PhaseSelect({ value, info, onChange, disabled = false, label = null }) {
  const options = {
    "Single phase": { title: "Single phase", value: 1 },
    "Three phases": { title: "Three phases", value: 3 },
  };

  return (
    <HelpedSelect
      valueKey="value"
      optionKey="title"
      options={options}
      selected={value}
      onChange={onChange}
      label={label}
      info={info}
      disabled={disabled}
    />
  );
}
